import React from 'react'
import ContactPost from './Contact-post'
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";
import '../Contact/Contact.css'
const Contact = () => {
  return (
    <>
        <ContactPost/>

      <div className="contact-container-cs">
      <div className="contact-header-cs">
        <p className="contact-subtitle-cs">Contact Us</p>
        <h1 className="contact-title-cs">Feel Free to Write us</h1>
      </div>

      <div className="contact-content-cs">
        <div className="contact-info-cs">
          <div className="info-card-cs">
            <div className="info-image-wrapper-cs">
              <img 
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf" 
                alt="Contact" 
                className="info-image-cs"
              />
              <div className="image-badge-cs">Contact Information</div>
            </div>
            
            <div className="contact-details-cs">
              <div className="detail-item-cs">
                <div className="icon-circle-cs">
                  <FiPhone className="contact-icon-cs" />
                </div>
                <div className="detail-text-cs">
                  <h3>Phone</h3>
                  <p>+1 234 567 8900</p>
                </div>
              </div>
              
              <div className="divider-cs"></div>
              
              <div className="detail-item-cs">
                <div className="icon-circle-cs">
                  <FiMail className="contact-icon-cs" />
                </div>
                <div className="detail-text-cs">
                  <h3>Email</h3>
                  <p>info@example.com</p>
                </div>
              </div>
              
              <div className="divider-cs"></div>
              
              <div className="detail-item-cs">
                <div className="icon-circle-cs">
                  <FiMapPin className="contact-icon-cs" />
                </div>
                <div className="detail-text-cs">
                  <h3>Address</h3>
                  <p>123 Main Street, City, Country</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-form-section-cs">
          <h2 className="form-title-cs">Write a Message</h2>
          <form className="contact-form-cs">
            <div className="form-group-cs">
              <input type="text" placeholder="Your Name" className="form-input-cs" />
            </div>
            <div className="form-group-cs">
              <input type="email" placeholder="Your Email" className="form-input-cs" />
            </div>
            <div className="form-group-cs">
              <input type="tel" placeholder="Your Contact Number" className="form-input-cs" />
            </div>
            <div className="form-group-cs">
              <input type="text" placeholder="Subject" className="form-input-cs" />
            </div>
            <div className="form-group-cs">
              <textarea placeholder="Your Message" rows="5" className="form-textarea-cs"></textarea>
            </div>
            <button type="submit" className="submit-button-cs">Send a Message</button>
          </form>
        </div>
      </div>
    </div>

      <div id="map" className="responsive-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d448193.9510726024!2d76.7635522238011!3d28.644287343591763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x37205b715389640!2sDelhi!5e0!3m2!1sen!2sin!4v1720784592844!5m2!1sen!2sin"
            width={600}
            height={450}
            frameBorder={0}
            style={{ border: 0 }}
            allowFullScreen
          />
        </div>
    </>
  )
}

export default Contact